<div class="row justify-content-between align-items-center mb-2 zIndexUp">
    <h4 class="col-xl-auto col-lg-auto col-md-6 col-sm-6 mb-lg-0 mb-sm-2 mb-md-2 mb-2">Profile</h4>
    <a href="javascript:void(0);" class="font-weight-bold pr-3" routerLink="/change-password">Change Password</a>
</div>

<div class="form-row animated fadeIn">
    <div class="col-xl-2 col-lg-2 col-md-2">
        <div class="card overflow-hidden">
            <div class="card-body p-2">
                <div class="text-center">
                    <img src={{profileImgUrl}} alt="" class="img-fluid img-thumbnail">
                    <div class="w-100">
                        <h4 class="mt-3 font-bold text-info">{{userInformation['UserName']}}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-10 col-lg-10 col-md-10">
        <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Profile Information</h5>
            </div>
            <div class="card-body new-detail-page">
                <form>
                    <div class="form-row mt-3 odd">
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Employee Id :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.EmployeeId}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Employer Details :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.EmployeeDetails}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Employer Type :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.EmployeeType}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row even ">
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">User Name :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.UserName}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Email ID :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.EmailId}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Mobile :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.Mobile}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row odd ">

                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Business Verticals :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.BusinessVertical}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Designation :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.Designation}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Date of Join :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.DateOfJoin |
                                        date:'dd-MM-yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row even ">

                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Passport Number :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 mb-0 font-weight-bold">{{userInformation.PassportNumber}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Passport Validity :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.PassportValidity |
                                        date:'dd-MM-yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">QID :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.QID}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row odd ">
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">QID Validity :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.QIDValidity |
                                        date:'dd-MM-yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Gender :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.Gender}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">Country :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.CountryName}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row even ">
                        <div class="form-group col-lg-4 col-md-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-6 col col-form-label text-right">City :</label>
                                <div class="col-sm-6 col">
                                    <p class="pt-2 mb-0 font-weight-bold">{{userInformation.CityName}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>